export const PagePaths = {
  home: '/',
  aboutUs: '/about-us',
  services: '/services',
  showcase: '/showcase',
  contactUs: '/contact-us',
}

export const CUSTOMER_FEEDBACK_SECTION_FRAGMENT = 'customer-feedback-section'
